import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'User drags either the front or the back of the selected video so they can trim or recover what was trimmed',
  name: 'trim_video',
  params: [
    {
      description: 'Whether the user is trimming or extending the video',
      name: 'trim_type',
      required: true,
      type: 'enum',
      values: ['trim', 'extend'],
    },
    {
      description: 'Which end of the video the user is adjusting',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['front', 'back'],
    },
  ],
};

export default META;
